import { render, staticRenderFns } from "./documents-list-page.vue?vue&type=template&id=b4f49486&"
import script from "./documents-list-page.vue?vue&type=script&lang=js&"
export * from "./documents-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports